import VT from '@/store/types';

export default {
  [VT.PROJECT_LOAD]: (state, data) => {
    if (!data) {
      state.currentProjectId = null;
      return;
    }
    const project = data.data;
    state.currentProjectId = project.id;
    state.info = project;
  },
};
